import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box, Paper, } from '@mui/material';
import { getSignedAssetUrl, useStore } from '@mcn-platform/models';
import ActionButtons from '../class/lessonPanel/ActionButtons';
import InfoTabs from '../class/lessonPanel/InfoTabs';
import ItemContent from '../class/lessonPanel/ItemContent';
const DocumentContent = ({ document, seekPosition, seekTrigger, setCurrentPosition, updateProgress, showTranscripts, showOverview, showCTA, showMakeANoteBtn, showDownloadButton, }) => {
    const store = useStore();
    const { isAnonymous } = store;
    const { ctaLabel, ctaUrl, ctaNewWindow, } = document;
    const OnMediaProgress = (progress) => {
        if (setCurrentPosition) {
            setCurrentPosition(Math.floor(progress));
        }
    };
    const onPause = () => {
        // updateProgress();
    };
    const OnComplete = () => {
        if (updateProgress) {
            updateProgress(100);
        }
    };
    const downloadAction = () => {
        getSignedAssetUrl(document?.asset, undefined, store).then((signedUrl) => {
            window.open(signedUrl, '_blank');
        });
    };
    if (!document) {
        return _jsx(Box, { children: "Select lesson" });
    }
    return (_jsx(Paper, { sx: { boxShadow: 0, backgroundColor: 'transparent' }, children: _jsxs(Box, { sx: {
                width: '100%',
                minHeight: '100%',
                borderRadius: 1,
                my: 2,
            }, children: [_jsx(ItemContent, { section: {
                        type: document.asset?.type,
                        item: document,
                    }, showPlayerControls: true, seekPosition: seekPosition, seekTrigger: seekTrigger, onProgress: OnMediaProgress, onPause: onPause, onEnd: OnComplete, handleNextPrevious: () => { }, actionButtons: (_jsx(ActionButtons, { showMakeANoteBtn: !isAnonymous && showMakeANoteBtn, showAddToListBtn: false, showShareBtn: false, showReportIssueBtn: false, showCTABtn: showCTA, ctaLabel: ctaLabel, ctaUrl: ctaUrl, openCTANewWindow: ctaNewWindow, downloadAction: showDownloadButton ? downloadAction : undefined })) }), _jsx(InfoTabs, { item: document, settings: {
                        defaultInfoTab: 0,
                        showMaterialTab: false,
                        showOverviewTab: showOverview,
                        showTranscriptTab: showTranscripts,
                    } })] }, document.id) }));
};
export default observer(DocumentContent);
//# sourceMappingURL=DocumentContent.js.map